<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">label</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Alterar tags</h2>
    <span class="modal-subtitle">Atualize as tags das notas selecionadas.</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button
      mat-icon-button
      type="button"
      class="modal-close-btn icon-mat-symbols-btn"
      (click)="fechar()"
      [disabled]="isLoading"
      aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p>O que deseja fazer com a(s) nota(s) selecionada(s)?</p>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Ação</mat-label>
    <mat-select [(ngModel)]="modo" (selectionChange)="alterarModo()">
      <mat-option [value]="acaoTags.Incluir">Incluir tags</mat-option>
      <mat-option [value]="acaoTags.Remover">Remover tags</mat-option>
    </mat-select>
  </mat-form-field>

  <p class="dialog-help">{{ helpText }}</p>

  <div class="tags-header">
    <strong>Selecione as tags</strong>
    @if (tagsSelecionadas.size > 0) {
      <span class="status-badge badge-vermelho">{{ contadorText }}</span>
    }
  </div>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Buscar tags</mat-label>
    <mat-icon matPrefix class="material-symbols-outlined">search</mat-icon>
    <input matInput [(ngModel)]="pesquisa" (ngModelChange)="filtrarTags()" />
  </mat-form-field>

  <div class="tag-list" role="list">
    @for (tag of tagsFiltradas; track tag.idTagNFeEntrada) {
      <div class="tag-item" (click)="alternarTag(tag.idTagNFeEntrada)">
        <mat-checkbox
          [checked]="isTagSelecionada(tag.idTagNFeEntrada)"
          (click)="$event.stopPropagation()"
          (change)="alternarTag(tag.idTagNFeEntrada)">
          <span class="tag-label"
            ><span class="tag-cor" [style.background-color]="tag.cor"></span>{{ tag.descricao }}</span
          >
        </mat-checkbox>
      </div>
    } @empty {
      <p class="empty-tags">Nenhuma tag encontrada.</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()" [disabled]="isLoading">
    Cancelar
  </button>
  <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isLoading" [disabled]="!podeAplicar"
    [attr.aria-label]="isLoading ? 'Aplicando tags' : 'Aplicar'" (click)="salvar()">
    Aplicar
    @if (isLoading) { <mat-spinner diameter="20"></mat-spinner> }
  </button>
</mat-dialog-actions>
